import { render, staticRenderFns } from "./kvkk-report-view.vue?vue&type=template&id=fdc316ba"
import script from "./kvkk-report-view.vue?vue&type=script&lang=js"
export * from "./kvkk-report-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports